export default __webpack_public_path__ + "static/media/character.4ba74a5b.png";